const $ = require('jquery');

// replace form required asterisks with lock icons (replace with icon of choice)
$('.gform_wrapper .gfield_required').each( function() {
    $(this).html('<i class="fas fa-asterisk"></i>');
});

// insert dropdown icons to gform select elements
$('.gform_wrapper .ginput_container_select').each( function() {
    $(this).append('<div class="field_icon"><i class="fas fa-sort"></i></div>');
});

// insert calendar icons to gform datepicker fields
$('.gform_wrapper .ginput_container_date').each( function() {
    $(this).prepend('<div class="field_icon"><i class="far fa-calendar-alt"></i></div>');
});

// insert phone icons to gform phone fields
$('.gform_wrapper .ginput_container_phone').each( function() {
    $(this).prepend('<div class="field_icon"><i class="fas fa-mobile-alt"></i></div>');
});

// insert envelope icons to gform mail fields
$('.gform_wrapper .ginput_container_email').each( function() {
    $(this).prepend('<div class="field_icon"><i class="fas fa-envelope"></i></div>');
});

// insert error icons to gform field error elements
$('.gform_wrapper .gfield.gfield_error .ginput_container:not(.ginput_container_checkbox):not(.ginput_container_radio):not(.ginput_container_select)').each( function() {
    $(this).append('<div class="error_icon"><i class="far fa-times"></i></div>');
});


// add loader and disabled class to gform submits to prevent multiple submits
$('.gform_wrapper form').submit( function(e) {
    let $submit = $(this).closest('.gform_wrapper').find('.gform_footer *[type="submit"]');

    if( !$submit.hasClass('btn-disabled') ) {
        $submit.addClass('btn-disabled').prepend('<i class="icon-left fas fa-spinner fa-spin"></i>').blur();
    } else {
        e.preventDefault();
    }
});


// hide .gform_heading if .gform_description is only child and is empty
$('.gform_wrapper .gform_heading .gform_description').each( function() {
    let $heading = $(this).closest('.gform_heading');
    let $description = $(this);

    // if description is empty, hide it
    if ($description.html() === '') {
        $description.hide();

        // if description is empty, and only child, hide heading
        if ($description.siblings().length < 1) {
            $heading.hide();
        }
    }
});


// remove top-margin from .gfield if its the first visible element in form following hidden fields
$('.gform_wrapper .gform_fields').each(function() {
    $('.gfield', this).each(function() {
        let $field = $(this);

        if ($field.hasClass('gform_hidden') || $field.hasClass('gfield_visibility_hidden')) {
            let $nextField = $field.next('.gfield:not(.gform_hidden):not(.gfield_visibility_hidden)');

            if ($nextField.length > 0) {
                $nextField.addClass('nomargin-top');
                return false;
            }
        }
    });
});
